(function () {
  // ---- CONFIG ----
  var OPEN_BTN_SEL = '.js-btn-quickview, [data-quickview-open], .btn-quickview';
  var MODAL_SEL    = '.quickview, #quick-view, [data-quickview], .product-quickview, .mfp-content .quickview, .fancybox-content .quickview';

  function getOpenModal() {
    var nodes = document.querySelectorAll(MODAL_SEL);
    for (var i = nodes.length - 1; i >= 0; i--) {
      var el = nodes[i];
      if (el.getAttribute('aria-hidden') === 'false' || el.offsetParent !== null) return el;
    }
    return null;
  }
  function toArr(n){ return Array.prototype.slice.call(n || []); }

  // Only treat as lazysizes candidate if it actually has lazy data attrs
  function isLazyCandidate(el){
    return el && (
      el.hasAttribute('data-src') ||
      el.hasAttribute('data-srcset') ||
      el.hasAttribute('data-bg') ||
      el.hasAttribute('data-bgset')
    );
  }
  function unveil(el){
    try {
      if (!el.classList.contains('lazyload')) el.classList.add('lazyload');
      if (window.lazySizes && lazySizes.loader && lazySizes.loader.unveil) {
        lazySizes.loader.unveil(el);
      }
    } catch(e){}
  }

  function refreshCarousels(modal){
    // Nudge layout either way
    try { window.dispatchEvent(new Event('resize')); } catch(e){}
    if (window.jQuery) {
      var $ = window.jQuery;
      $(modal).find('.slick, .slick-slider, .slick-initialized').each(function(){
        try { $(this).slick('setPosition').slick('refresh'); } catch(e){}
      });
    }
  }

  function onOpen(){
    // Wait for the modal DOM to mount
    setTimeout(function(){
      var modal = getOpenModal();
      if (!modal) return;

      // Unveil the hero only if it’s truly lazy
      var hero = modal.querySelector('img[data-role="main"], .quickview-images img, .product-media img, .product-image img, img');
      if (isLazyCandidate(hero)) unveil(hero);

      // (Optional) also prep other lazy candidates inside modal
      toArr(modal.querySelectorAll('img[data-src], img[data-srcset], source[data-srcset], [data-bgset], [data-bg]'))
        .forEach(unveil);

      // Refresh carousels a few times to fix width/opacity issues
      [100, 300, 600].forEach(function(delay){ setTimeout(function(){ refreshCarousels(modal); }, delay); });

      // Last-resort fallback: if hero still blank, promote to eager
      setTimeout(function(){
        if (!hero) return;
        var ok = hero.complete && hero.naturalWidth > 1;
        if (!ok) {
          var ds  = hero.getAttribute('data-src');
          var dss = hero.getAttribute('data-srcset');
          if (ds && !hero.src)     hero.src     = ds;
          if (dss && !hero.srcset) hero.srcset  = dss;
          hero.setAttribute('loading','eager');
          hero.setAttribute('fetchpriority','high');
        }
      }, 500);
    }, 120);
  }

  // Hook button clicks (works even if your theme uses dynamic markup)
  document.addEventListener('click', function(e){
    var btn = e.target.closest(OPEN_BTN_SEL);
    if (btn) onOpen();
  });

  // Also support theme events if they exist
  document.addEventListener('quickview:opened', onOpen);
  document.addEventListener('QuickView:open',  onOpen);
})();



(function(){
  // Treat these keywords as digital/ebook
  var DIGITAL = /(ebook|e-book|digital|pdf|guide|cookbook)/i;

  function drawerHasDigital(){
    var items = document.querySelectorAll('.ajaxcart__product, .ajaxcart__line-item');
    if (!items.length) return false;
    for (var i=0;i<items.length;i++){
      var item = items[i];
      var nameEl = item.querySelector('.ajaxcart__product-name');
      var name   = nameEl ? nameEl.textContent : '';
      var handleEl = item.querySelector('[data-handle]');
      var handle   = handleEl ? (handleEl.getAttribute('data-handle') || '') : '';
      if (DIGITAL.test(name) || DIGITAL.test(handle)) return true; // any digital item
    }
    return false;
  }

  function togglePolicies(){
    var policies = document.querySelector('.ajaxcart__policies');
    if (!policies) return;
    policies.style.display = drawerHasDigital() ? 'none' : '';
  }

  // Initial run
  togglePolicies();

  // Re-run when the drawer updates
  new MutationObserver(function(muts){
    for (var i=0;i<muts.length;i++){
      if (muts[i].addedNodes && muts[i].addedNodes.length){ togglePolicies(); break; }
    }
  }).observe(document.body, {childList:true, subtree:true});

  // Re-run after common cart actions
  document.addEventListener('click', function(e){
    if (e.target.closest('.ajaxcart__qty-adjust,[data-cart-remove],.header-cart,.cart-icon,[data-open-cart],.open-cart')){
      setTimeout(togglePolicies, 120);
    }
  });
})();





(function () {
  // prevent double install
  if (window.__SPZ_FBWEBVIEW_FIX__) return;
  window.__SPZ_FBWEBVIEW_FIX__ = true;

  // 1) Detect FB/IG in-app browser and expose globally
  try {
    var ua = navigator.userAgent || "";
    window.isFBWebView = /\bFBAN|FBAV|Instagram\b/i.test(ua);
  } catch (e) {
    window.isFBWebView = false;
  }

  // 2) Passive, rAF-driven scroll toggle for "back to top" buttons
  try {
    var ticking = false;
    var selScrollBtn = ".js-scroll-to-top";

    function onScrollRAF() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      var nodes = document.querySelectorAll(selScrollBtn);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (y >= 200) {
          n.style.display = "block";
          n.style.opacity = "1";
        } else {
          n.style.opacity = "0";
          n.style.display = "none";
        }
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(onScrollRAF);
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
  } catch (e) {}

  // 3) Disable jQuery smooth scroll animations for html/body in FB/IG only
  try {
    if (window.jQuery && window.isFBWebView) {
      var _animate = jQuery.fn.animate;
      jQuery.fn.animate = function (props, speed, easing, cb) {
        try {
          // If the target is ONLY html/body and only scrollTop is being animated, jump instead
          var onlyHtmlBody =
            this.length &&
            this.filter("html, body, body,html").length === this.length;

          var hasScrollTop =
            props && Object.prototype.hasOwnProperty.call(props, "scrollTop");

          if (onlyHtmlBody && hasScrollTop) {
            window.scrollTo(0, props.scrollTop | 0);
            if (typeof cb === "function") cb.call(this);
            return this;
          }
        } catch (e) {}
        return _animate.apply(this, arguments);
      };
    }
  } catch (e) {}

  // 4) Non-blocking popup CSS (cookie/newsletter) to avoid layout shift
  try {
    var css =
      ".cookie-consent, .js-newsletter-popup{" +
      "position:fixed!important;left:0;right:0;bottom:0;z-index:2147483000;" +
      "transform:translateY(0);opacity:0;transition:opacity .25s ease,transform .25s ease;" +
      "will-change:opacity,transform}" +
      ".cookie-consent.active,.js-newsletter-popup.show{opacity:1}";
    var s = document.createElement("style");
    s.type = "text/css";
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  } catch (e) {}

  // 5) Stagger non-critical work slightly after first paint
  var idle = window.requestIdleCallback || function (cb) { setTimeout(cb, 200); };
  idle(function () {
    try {
      document.dispatchEvent(new CustomEvent("noncritical:init"));
    } catch (e) {}
  });
})();





/* Omnisend → FBQ bridge (non-blocking) */
 
    window.addEventListener("omnisendForms", function(e) {
      if (!e || !e.detail || !e.detail.form || typeof fbq !== "function") return;
      var f = e.detail.form, id = String(f.id), name = f.name;
      switch (e.detail.type) {
        case 'view': fbq('trackCustom','omnisend_form_view',{form_name:name, form_id:id}); break;
        case 'interaction': fbq('trackCustom','omnisend_form_interaction',{form_name:name, form_id:id}); break;
        case 'submit': fbq('trackCustom','omnisend_form_submit',{form_name:name, form_id:id}); fbq('track','Lead',{content_name:name, content_ids:[id]}); break;
        case 'close': fbq('trackCustom','omnisend_form_close',{form_name:name, form_id:id}); break;
        case 'stepView': fbq('trackCustom','omnisend_form_step_view',{form_name:name, form_id:id}); break;
        case 'stepInteraction': fbq('trackCustom','omnisend_form_step_interaction',{form_name:name, form_id:id}); break;
        case 'stepSubmit': fbq('trackCustom','omnisend_form_step_submit',{form_name:name, form_id:id}); break;
      }
    });






    // SPZ – Force "SALE" Badge (deferred, variant-safe, non-blocking)
document.addEventListener('DOMContentLoaded', () => {
  const setSaleBadge = (el) => {
    if (!el) return;
    if (el.textContent.trim() !== 'SALE') el.textContent = 'SALE';
    el.style.display = 'inline-block';
  };

  const forceAll = () => {
    document.querySelectorAll('.js-force-sale').forEach(setSaleBadge);
  };

  // Run immediately after DOM ready
  forceAll();

  // When variant changes (Shopify event)
  document.addEventListener('variant:changed', forceAll);

  // Watch for DOM mutations (e.g. dynamic rewrites)
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'childList' || m.type === 'characterData') {
        if (m.target.nodeType === 3 && m.target.parentNode?.closest('.js-force-sale')) {
          forceAll();
          break;
        }
      }
    }
  });

  // Observe sale elements for dynamic changes
  document.querySelectorAll('.js-force-sale').forEach((el) => {
    observer.observe(el, { subtree: true, characterData: true, childList: true });
  });
});
